import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./privacy.css";
import heroImg from "../TestImages/StockCake-Serene_Workspace_Sanctuary-2089290-standard.jpg";

function Privacy() {
  return (
    <div>
      {/* HERO / BANNER */}
      <div className="hero pt-4">
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${heroImg})` }}
        />
        <div className="hero-overlay" />

        <Container className="hero-inner pt-5">
          <h1 className="hero-title">Privacy Policy</h1>
          <p className="hero-subtitle">
            How we collect, use, and protect your information.
          </p>
        </Container>
      </div>

      {/* CONTENT */}
      <Container className="privacy-container">
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={9}>
            <div className="privacy-panel">

              {/* INTRODUCTION */}
              <div className="privacy-intro">
                <div className="privacy-tagline">YOUR PRIVACY MATTERS</div>

                <h2 className="privacy-headline">
                  Privacy Policy
                </h2>

                <p className="privacy-text">
                  Last Updated: August 15, 2026
                </p>

                <p className="privacy-text">
                  Welcome to Stedi. We are committed to protecting your
                  privacy and ensuring that your personal information is handled
                  in a safe and responsible manner. This Privacy Policy explains
                  how we collect, use, disclose, and protect information when
                  you access or use the Stedi application, website, products,
                  and related services.
                </p>

                <p className="privacy-text">
                  By using Stedi, creating an account, purchasing products, or
                  otherwise providing information to us, you acknowledge the
                  practices described in this Privacy Policy.
                </p>
              </div>

              {/* SECTION 1 */}
              <div className="privacy-section">
                <div className="privacy-section-number">1</div>

                <div>
                  <h3 className="privacy-section-title">
                    Information We Collect
                  </h3>

                  <p className="privacy-text">
                    We collect various types of information in connection with
                    the services and products we provide, including:
                  </p>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      a. Personal Information
                    </h4>

                    <p className="privacy-text">
                      <strong>Account Information:</strong> When you create an
                      account, we may collect your name, email address, phone
                      number, and other contact information.
                    </p>

                    <p className="privacy-text">
                      <strong>Profile Information:</strong> We may collect
                      information you provide when setting up or maintaining
                      your profile, such as a profile picture, goals,
                      preferences, and other information you choose to provide.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      b. Prospect Information
                    </h4>

                    <p className="privacy-text">
                      We collect information about the prospects you manage
                      through Stedi, including contact details, life cycle stage,
                      notes, reminders, interests, and other information that
                      you choose to maintain through the App.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      c. Calendar and Reminder Information
                    </h4>

                    <p className="privacy-text">
                      With your permission, Stedi may access or interact with
                      your Apple Calendar and Apple Reminders to schedule calls,
                      events, meetings, and reminders.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      d. Team and Collaboration Information
                    </h4>

                    <p className="privacy-text">
                      We collect information related to teams you join,
                      resources and content that are shared, team activity,
                      training progress, and communications within team chats
                      and direct messages.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      e. Usage and Device Information
                    </h4>

                    <p className="privacy-text">
                      We may collect information about how you use Stedi,
                      including the features you interact with, content you
                      view, actions you take, device information, application
                      activity, and diagnostic or performance information.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      f. Order and Purchase Information
                    </h4>

                    <p className="privacy-text">
                      When you purchase physical goods through Stedi, we may
                      collect information associated with your order, including
                      the products purchased, quantities, purchase price,
                      discounts, order status, transaction history, returns,
                      refunds, and other information necessary to process and
                      maintain your order.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      g. Shipping and Billing Information
                    </h4>

                    <p className="privacy-text">
                      When purchasing physical goods, we may collect your
                      shipping address, billing address, recipient name,
                      telephone number, email address, and other information
                      necessary to process, ship, deliver, return, or otherwise
                      support your order.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      h. Payment and Transaction Information
                    </h4>

                    <p className="privacy-text">
                      When you make a purchase, payment information necessary
                      to complete the transaction may be collected and
                      processed. Payments may be processed through third-party
                      payment processing providers.
                    </p>

                    <p className="privacy-text">
                      Depending on the payment method and payment provider used,
                      Stedi may receive limited payment-related information,
                      such as transaction identifiers, payment status, the
                      amount paid, payment method type, and limited details
                      associated with the payment method.
                    </p>

                    <p className="privacy-text">
                      Payment processors may collect and process payment card
                      information and other financial information in accordance
                      with their own privacy policies, terms, and security
                      practices.
                    </p>
                  </div>
                </div>
              </div>

              {/* SECTION 2 */}
              <div className="privacy-section">
                <div className="privacy-section-number">2</div>

                <div>
                  <h3 className="privacy-section-title">
                    How We Use Your Information
                  </h3>

                  <p className="privacy-text">
                    We may use the information we collect to:
                  </p>

                  <ul className="privacy-list">
                    <li>
                      Provide, operate, maintain, and improve Stedi and its
                      features.
                    </li>

                    <li>
                      Create and manage user accounts and profiles.
                    </li>

                    <li>
                      Facilitate communication and collaboration between team
                      members.
                    </li>

                    <li>
                      Schedule and manage calls, events, meetings, and
                      reminders.
                    </li>

                    <li>
                      Personalize your experience and provide relevant content.
                    </li>

                    <li>
                      Process purchases and payment transactions.
                    </li>

                    <li>
                      Confirm, fulfill, package, ship, deliver, and track orders
                      for physical goods.
                    </li>

                    <li>
                      Process returns, exchanges, refunds, and other
                      order-related requests.
                    </li>

                    <li>
                      Communicate with you regarding purchases, payments,
                      shipping, delivery, returns, and account activity.
                    </li>

                    <li>
                      Detect, investigate, and prevent fraudulent,
                      unauthorized, or potentially illegal transactions or
                      activity.
                    </li>

                    <li>
                      Respond to your inquiries and provide customer support.
                    </li>

                    <li>
                      Monitor and analyze usage, performance, and trends to
                      improve Stedi.
                    </li>

                    <li>
                      Maintain the security and integrity of Stedi and our
                      services.
                    </li>

                    <li>
                      Maintain business, accounting, transaction, and other
                      records.
                    </li>

                    <li>
                      Comply with legal, regulatory, tax, accounting, and
                      financial obligations.
                    </li>

                    <li>
                      Enforce our agreements, policies, and terms.
                    </li>
                  </ul>
                </div>
              </div>

              {/* SECTION 3 */}
              <div className="privacy-section">
                <div className="privacy-section-number">3</div>

                <div>
                  <h3 className="privacy-section-title">
                    How We Share Information
                  </h3>

                  <p className="privacy-text">
                    We may share personal information when reasonably necessary
                    to operate Stedi, provide our services, fulfill orders, and
                    process transactions.
                  </p>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      Payment Processors
                    </h4>

                    <p className="privacy-text">
                      We may provide or make information available to payment
                      processors and financial service providers as necessary to
                      authorize payments, process transactions, issue refunds,
                      prevent fraud, and resolve payment-related disputes.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      Shipping and Fulfillment Providers
                    </h4>

                    <p className="privacy-text">
                      We may share information such as your name, shipping
                      address, email address, phone number, and order
                      information with shipping carriers, fulfillment
                      providers, manufacturers, or other service providers as
                      necessary to fulfill and deliver physical goods.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      Service Providers
                    </h4>

                    <p className="privacy-text">
                      We may use third-party companies and service providers to
                      help operate Stedi and our business. These providers may
                      assist with services such as hosting, cloud storage,
                      analytics, customer support, communications, security,
                      payment processing, and order fulfillment.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      Legal and Safety Requirements
                    </h4>

                    <p className="privacy-text">
                      We may disclose information if we believe disclosure is
                      reasonably necessary to comply with applicable laws,
                      regulations, legal processes, or governmental requests; to
                      enforce our agreements and policies; or to protect the
                      rights, property, safety, and security of Stedi, our
                      users, or others.
                    </p>
                  </div>

                  <div className="privacy-subsection">
                    <h4 className="privacy-subsection-title">
                      Business Transfers
                    </h4>

                    <p className="privacy-text">
                      If Stedi is involved in a merger, acquisition,
                      reorganization, financing, sale of assets, or similar
                      business transaction, information may be disclosed or
                      transferred as part of that transaction, subject to
                      applicable law.
                    </p>
                  </div>
                </div>
              </div>

              {/* SECTION 4 */}
              <div className="privacy-section">
                <div className="privacy-section-number">4</div>

                <div>
                  <h3 className="privacy-section-title">
                    Payment Processing
                  </h3>

                  <p className="privacy-text">
                    Stedi may use third-party payment processors to facilitate
                    purchases made through the App. When payment information is
                    provided during checkout, that information may be
                    transmitted directly to or otherwise processed by the
                    applicable payment provider.
                  </p>

                  <p className="privacy-text">
                    Payment providers may independently collect, use, store, and
                    protect your information in accordance with their own terms
                    and privacy policies. We encourage you to review the privacy
                    practices of the payment provider used when completing a
                    transaction.
                  </p>

                  <p className="privacy-text">
                    We may retain transaction information necessary for
                    accounting, customer support, fraud prevention, refunds,
                    order management, and compliance with applicable legal and
                    financial obligations.
                  </p>
                </div>
              </div>

              {/* SECTION 5 */}
              <div className="privacy-section">
                <div className="privacy-section-number">5</div>

                <div>
                  <h3 className="privacy-section-title">
                    Data Security
                  </h3>

                  <p className="privacy-text">
                    We implement reasonable administrative, technical, and
                    organizational safeguards designed to protect your
                    information from unauthorized access, loss, misuse,
                    alteration, or disclosure.
                  </p>

                  <p className="privacy-text">
                    We also work with service providers, including payment
                    processors, that maintain their own security procedures for
                    the information they process.
                  </p>

                  <p className="privacy-text">
                    However, no method of transmission over the internet,
                    electronic payment system, or electronic storage system can
                    be guaranteed to be completely secure. Accordingly, we
                    cannot guarantee the absolute security of your information.
                  </p>
                </div>
              </div>

              {/* SECTION 6 */}
              <div className="privacy-section">
                <div className="privacy-section-number">6</div>

                <div>
                  <h3 className="privacy-section-title">
                    Data Retention
                  </h3>

                  <p className="privacy-text">
                    We retain personal information for as long as reasonably
                    necessary to provide Stedi and our services, maintain your
                    account, fulfill orders, process transactions, resolve
                    disputes, prevent fraud, enforce our agreements, and comply
                    with legal, tax, accounting, and regulatory requirements.
                  </p>

                  <p className="privacy-text">
                    Different types of information may be retained for different
                    periods depending on the purpose for which the information
                    was collected and our legal or business requirements.
                  </p>
                </div>
              </div>

              {/* SECTION 7 */}
              <div className="privacy-section">
                <div className="privacy-section-number">7</div>

                <div>
                  <h3 className="privacy-section-title">
                    Your Choices and Rights
                  </h3>

                  <p className="privacy-text">
                    You may access or update certain personal information
                    through the App's settings. You may also manage
                    notifications and other available preferences.
                  </p>

                  <p className="privacy-text">
                    Depending on where you live, applicable law may provide you
                    with additional rights regarding your personal information,
                    which may include the right to request access, correction,
                    deletion, or information about how your personal
                    information is used or disclosed.
                  </p>

                  <p className="privacy-text">
                    Certain information may need to be retained even after an
                    account deletion request, including transaction, order,
                    payment, tax, fraud-prevention, or other information that we
                    are required or permitted to retain by law.
                  </p>

                  <p className="privacy-text">
                    If you wish to close your account, exercise an applicable
                    privacy right, or have concerns about your information,
                    please contact us.
                  </p>
                </div>
              </div>

              {/* SECTION 8 */}
              <div className="privacy-section">
                <div className="privacy-section-number">8</div>

                <div>
                  <h3 className="privacy-section-title">
                    Third-Party Services
                  </h3>

                  <p className="privacy-text">
                    Stedi may integrate with or rely on third-party services,
                    including payment processors, calendar services, shipping
                    providers, cloud service providers, analytics services, and
                    other business partners.
                  </p>

                  <p className="privacy-text">
                    When you interact with a third-party service, that
                    third-party's collection and use of your information may be
                    governed by its own privacy policy and terms. Stedi is not
                    responsible for the privacy practices of third parties that
                    operate independently from us.
                  </p>
                </div>
              </div>

              {/* SECTION 9 */}
              <div className="privacy-section">
                <div className="privacy-section-number">9</div>

                <div>
                  <h3 className="privacy-section-title">
                    Changes to This Privacy Policy
                  </h3>

                  <p className="privacy-text">
                    We may update this Privacy Policy from time to time to
                    reflect changes to Stedi, our products and services, our
                    business practices, or applicable requirements.
                  </p>

                  <p className="privacy-text">
                    When we make changes, we will post the updated Privacy
                    Policy on this page and update the "Last Updated" date. We
                    encourage you to periodically review this Privacy Policy for
                    changes.
                  </p>
                </div>
              </div>

              {/* SECTION 10 */}
              {/* <div className="privacy-section privacy-contact-section">
                <div className="privacy-section-number">10</div>

                <div>
                  <h3 className="privacy-section-title">
                    Contact Us
                  </h3>

                  <p className="privacy-text mb-0">
                    If you have any questions or concerns about this Privacy
                    Policy, our privacy practices, or your personal information,
                    please contact us at{" "}
                    <a
                      href="mailto:Stedi@gmail.com"
                      className="privacy-email"
                    >
                      Stedi@gmail.com
                    </a>
                    .
                  </p>
                </div>
              </div> */}

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Privacy;